import { conversationStyleOptions } from '../../views/containers/AIAssistant/constant'
import {
  SET_DATASOURCE_OPTIONS,
  ADD_DATASOURCE,
  TOGGLE_ACTIVE_DATASOURCE,
  REMOVE_DATASOURCE,
  CLEAR_DATASOURCES,
  SET_CONVERSATION_STYLE,
  SET_DATASOURCE_MODAL
} from '../constants/chatbotConstants'

const initialState = {
  chatTheme: 'primary',
  isNewConversation: true,
  datasourceModal: {
    isOpen: false,
    data: null
  },
  conversationStyle: conversationStyleOptions.find((option) => option.name === 'Precise') || null,
  dataSources: [
    // {
    //   id: 'webSearch',
    //   name: 'Web Search',
    //   isActive: true,
    //   options: [],
    //   selectedOptions: null
    // }
  ]
}

export default function chatbotReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_DATASOURCE: {
      const updatedDataSources = state.dataSources?.some(
        (dataSource) => dataSource.id === action.payload.id
      )
        ? state.dataSources?.map((dataSource) => {
            return dataSource.id === action.payload.id ? { ...action.payload } : dataSource
          })
        : [...state.dataSources, action.payload]
      return {
        ...state,
        dataSources: updatedDataSources
      }
    }
    case TOGGLE_ACTIVE_DATASOURCE: {
      const updatedDataSources = state.dataSources?.map((dataSource) => {
        return dataSource.id === action.payload.id
          ? { ...dataSource, isActive: action.payload.isActive }
          : dataSource
      })
      return {
        ...state,
        dataSources: updatedDataSources
      }
    }
    case REMOVE_DATASOURCE: {
      return {
        ...state,
        dataSources: state.dataSources.filter((dataSource) => dataSource.id !== action.payload.id)
      }
    }
    case CLEAR_DATASOURCES: {
      return {
        ...state,
        dataSources: state.dataSources.filter((dataSource) => dataSource.id === 'webSearch')
      }
    }
    case SET_DATASOURCE_OPTIONS: {
      return {
        ...state,
        dataSources: state.dataSources.map((dataSource) => {
          return dataSource.id === action.payload.id
            ? {
                ...dataSource,
                selectedOptions: { ...action.payload.selectedOptions }
              }
            : dataSource
        })
      }
    }
    case SET_CONVERSATION_STYLE: {
      return {
        ...state,
        conversationStyle: action.payload
      }
    }
    case SET_DATASOURCE_MODAL: {
      return {
        ...state,
        datasourceModal: { isOpen: action.payload.isOpen, data: action.payload.data }
      }
    }
    default:
      return state
  }
}
